import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
/**
 * Fallback of IE.
 * Safe to remove.
 */
// Style as inline component
import { prepareToken } from '.';
import { genSubStyleComponent } from '../../theme/internal';
// ============================= Fallback =============================
var genFallbackStyle = function genFallbackStyle(token) {
  var formItemCls = token.formItemCls;
  return {
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': _defineProperty({}, "".concat(formItemCls, "-control"), {
      display: 'flex'
    })
  };
};
// ============================== Export ==============================
export default genSubStyleComponent(['Form', 'item-item'], function (token, _ref) {
  var rootPrefixCls = _ref.rootPrefixCls;
  var formToken = prepareToken(token, rootPrefixCls);
  return [genFallbackStyle(formToken)];
});